import React from 'react';
import styled from 'styled-components';
// import { Link } from 'react-router-dom';
// Import with the correct file extension case
import momWithDogs from '../../assets/images/MomWithDogs.JPEG';

const Section = styled.section`
  padding: 6rem 0;
  background-color: ${({ theme }) => theme.colors.background};
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    top: -20px;
    left: -20px;
    width: 60%;
    height: 60%;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    z-index: 1;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    order: 1;
    
    &:before {
      width: 40%;
      height: 40%;
    }
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  position: relative;
  z-index: 2;
  box-shadow: ${({ theme }) => theme.shadows.medium};
`;

const Content = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    order: 2;
  }
`;

const Subtitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.accent};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.2rem;
  display: block;
  margin-bottom: 1rem;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.8;
  margin-bottom: 2rem;
`;

// const Button = styled(Link)`
//   display: inline-block;
//   background-color: transparent;
//   color: ${({ theme }) => theme.colors.primary};
//   padding: 0.8rem 2rem;
//   border: 1px solid ${({ theme }) => theme.colors.primary};
//   border-radius: ${({ theme }) => theme.borderRadius.small};
//   font-size: 0.9rem;
//   text-transform: uppercase;
//   letter-spacing: 1px;
//   transition: all 0.3s ease;
  
//   &:hover {
//     background-color: ${({ theme }) => theme.colors.primary};
//     color: ${({ theme }) => theme.colors.background};
//   }
// `;

const AboutSection: React.FC = () => {
  return (
    <Section id="about">
      <Container>
        <ImageContainer>
          <Image 
            src={momWithDogs}
            alt="Adriana with Dogs" 
          />
        </ImageContainer>
        <Content>
          <Subtitle>Our Story</Subtitle>
          <Title>Handcrafted with Love and Precision</Title>
          <Description>
            The name "Ajana" emerged from childhood whispers - a tender nickname bestowed upon our founder Adriana by her siblings. 
            What began as a term of endearment has blossomed into our philosophy: the belief that jewelry marks the milestones in our personal journeys, 
            capturing moments of transformation and self-discovery in precious metal and stone.
          </Description>
          <Description>
            Our designs blend contemporary aesthetics with classic elegance, resulting in pieces that are both modern and timeless. 
            We believe that jewelry should not only be beautiful but also tell a story and hold meaning for the wearer.
          </Description>
          {/* <Button to="/about">Learn More</Button> */}
        </Content>
      </Container>
    </Section>
  );
};

export default AboutSection;
